<template>
    <!-- ------------------------------------- 表格 ----------------------------------- -->
    <div class="forms">
        <!-- 选择机件型号 -->
        <div v-if="!noArr.includes('models')" class="form_box">
            <!-- 图标 -->
            <div class="icon_box">
                <img
                    class="icon_models"
                    src="../assets/images/icon/icon-tag.png"
                    alt=""
                />
            </div>
            <!-- 选项 -->
            <el-select
                v-model="formData1.modelsValue"
                class="options"
                placeholder="选择机件型号*"
            >
                <el-option
                    v-for="(item, index) in modelsList"
                    :value="item.name"
                    :key="index"
                >
                    {{ item.name }}
                </el-option>
            </el-select>
        </div>
        <!-- 请选择省份 -->
        <div v-if="!noArr.includes('province')" class="form_box">
            <!-- 图标 -->
            <div class="icon_box">
                <img
                    class="icon_province"
                    src="../assets/images/icon/icon-paper.png"
                    alt=""
                />
            </div>
            <el-select
                v-model="formData1.provinceValue"
                class="options"
                placeholder="请选择省份"
                @change="getCity"
            >
                <el-option
                    v-for="(item, index) in provinceList"
                    :label="item.provinceCn"
                    :value="item.id"
                    :key="index"
                >
                    {{ item.provinceCn }}
                </el-option>
            </el-select>
        </div>
        <!-- 请选择城市 -->
        <div v-if="!noArr.includes('city')" class="form_box">
            <!-- 图标 -->
            <div class="icon_box">
                <img
                    class="icon_city"
                    src="../assets/images/icon/icon-tag.png"
                    alt=""
                />
            </div>
            <el-select
                v-model="formData1.cityValue"
                class="options"
                placeholder="请选择城市"
                no-data-text="无数据"
            >
                <el-option
                    v-for="(item, index) in cityList"
                    :value="item.id"
                    :label="item.cityCn"
                    :key="index"
                >
                    {{ item.cityCn }}
                </el-option>
            </el-select>
        </div>
        <!-- 请输入服务详细地址 -->
        <div v-if="!noArr.includes('serviceAddress')" class="form_box">
            <!-- 图标 -->
            <div class="icon_box">
                <img
                    class="icon_serviceAddress"
                    src="../assets/images/icon/icon-building.png"
                    alt=""
                />
            </div>
            <el-input
                v-model="formData1.serviceValue"
                class="options"
                placeholder="请输入服务详细地址"
            ></el-input>
        </div>
        <!-- 请输入详情地址 -->
        <div v-if="!noArr.includes('adress')" class="form_box">
            <!-- 图标 -->
            <div class="icon_box">
                <img
                    class="icon_adress"
                    src="../assets/images/icon/icon-building.png"
                    alt=""
                />
            </div>
            <el-input
                v-model="formData1.adressValue"
                class="options"
                placeholder="请输入详情地址"
            ></el-input>
        </div>
        <!-- 请输入姓名 -->
        <div v-if="!noArr.includes('name')" class="form_box">
            <!-- 图标 -->
            <div class="icon_box">
                <img
                    class="icon_name"
                    src="../assets/images/icon/icon-man.png"
                    alt=""
                />
            </div>
            <el-input
                maxlength="50"
                v-model="formData1.nameValue"
                class="options"
                placeholder="请输入姓名"
            ></el-input>
        </div>
        <!-- 请输入公司名称 -->
        <div v-if="!noArr.includes('company')" class="form_box">
            <!-- 图标 -->
            <div class="icon_box">
                <img
                    class="icon_company"
                    src="../assets/images/icon/icon-mansion.png"
                    alt=""
                />
            </div>
            <el-input
                v-model="formData1.companyValue"
                class="options"
                placeholder="请输入公司名称"
            ></el-input>
        </div>
        <!-- 请输入手机号码 -->
        <div v-if="!noArr.includes('phone')" class="form_box">
            <!-- 图标 -->
            <div class="icon_box">
                <img
                    class="icon_phone"
                    src="../assets/images/icon/icon-phone.png"
                    alt=""
                />
            </div>
            <el-input
                v-model="formData1.phoneValue"
                class="options"
                placeholder="请输入手机号码"
                @blur="phoneRule"
            ></el-input>
        </div>
        <!-- 请输入电子邮箱 -->
        <div v-if="!noArr.includes('eamil')" class="form_box">
            <!-- 图标 -->
            <div class="icon_box">
                <img
                    class="icon_eamil"
                    src="../assets/images/icon/icon-email.png"
                    alt=""
                />
            </div>
            <el-input
                v-model="formData1.eamilValue"
                class="options"
                placeholder="请输入电子邮箱"
                @blur="emailRule"
            ></el-input>
        </div>
        <!-- 请选择客户来源 -->
        <div v-if="!noArr.includes('customer')" class="form_box">
            <!-- 图标 -->
            <div class="icon_box">
                <img
                    class="icon_customer"
                    src="../assets/images/icon/icon-crosshair.png"
                    alt=""
                />
            </div>
            <el-select
                v-model="formData1.customerValue"
                class="options"
                placeholder="请选择客户来源*"
            >
                <el-option
                    v-for="(item, index) in customerList"
                    :value="item.name"
                    :label="item.name"
                    :key="index"
                >
                    {{ item.name }}
                </el-option>
            </el-select>
        </div>
        <!-- 请输入邀请码 -->
        <div v-if="!noArr.includes('code')" class="form_box">
            <!-- 图标 -->
            <div class="icon_box" style="margin-left: 1.3%">
                <img
                    class="icon_code"
                    src="../assets/images/icon/icon-message.png"
                    alt=""
                />
            </div>
            <div style="width: 100%; display: flex">
                <el-select
                    v-model="formData1.code"
                    class="options"
                    @change="qingKong"
                    placeholder="邀请码"
                    style="margin-left: 2%"
                >
                    <el-option :value="1" label="没有">没有</el-option>
                    <el-option :value="2" label="有">有</el-option>
                </el-select>
                <el-select
                    v-if="formData1.code === 1"
                    v-model="formData1.codeTwo"
                    class="options"
                    placeholder="选择"
                >
                    <el-option :value="1" label="确定没有">确定没有</el-option>
                    <el-option :value="2" label="不清楚">不清楚</el-option>
                </el-select>
                <el-input
                    v-if="formData1.code === 2"
                    v-model="formData1.codeTwo"
                    class="options"
                    placeholder="请输入邀请码"
                >
                </el-input>
            </div>
        </div>
        <!-- 立即安排我的免费空气检测 -->
        <div
            v-if="!noArr.includes('nowDetection')"
            class="form_button"
            @click="yyAirjiance"
        >
            <div class="button_title" style="color: #5a357f">
                立即安排我的免费空气检测
            </div>
            <div class="button_icon">
                <img
                    src="../assets/images/icon/play-white.png"
                    alt=""
                    style="background: #5a357f"
                />
            </div>
        </div>
        <!-- 立即安排我的免费空气检测 -->
        <div
            v-if="!noArr.includes('nowDetectionOrigan')"
            class="form_button"
            @click="zx1"
        >
            <div class="button_title">提交</div>
            <div class="button_icon">
                <img src="../assets/images/icon/play-white.png" alt="" />
            </div>
        </div>
        <!-- 立即安排我的机件清洁服务 -->
        <div
            v-if="!noArr.includes('nowClean')"
            class="form_button"
            @click="zx1"
        >
            <div class="button_title">提交</div>
            <div class="button_icon">
                <img src="../assets/images/icon/play-white.png" alt="" />
            </div>
        </div>
        <!-- 立即延长我的维保服务 -->
        <div
            v-if="!noArr.includes('nowExtended')"
            class="form_button"
            @click="zx1"
        >
            <div class="button_title">提交</div>
            <div class="button_icon">
                <img src="../assets/images/icon/play-white.png" alt="" />
            </div>
        </div>
        <!-- 立即安排我的专项空气测试 -->
        <div
            v-if="!noArr.includes('nowSpecial')"
            class="form_button"
            @click="zx1"
        >
            <div class="button_title">提交</div>
            <div class="button_icon">
                <img src="../assets/images/icon/play-white.png" alt="" />
            </div>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';

export default {
    props: {
        type: null,
        noArr: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    components: {},
    data() {
        return {
            agentAccount: [],
            // 机型选项
            modelsList: [
                {
                    name: 'x-srt0',
                },
                {
                    name: 's-ta02',
                },
            ],
            // 省份选项
            provinceList: [],
            phoneR: false,
            emailR: false,
            // 城市选项
            cityList: [],
            // 客户来源
            customerList: [],
            formData1: {
                modelsValue: '', //机型
                provinceValue: undefined, //省份
                cityValue: undefined, //城市
                customerValue: undefined, //客户
                nameValue: '', //姓名
                adressValue: '', //详情地址
                phoneValue: '', //手机号
                serviceAddress: '', //服务地址
                eamilValue: '', //电子邮箱
                codeOne: undefined,
                codeTwo: undefined,
                companyValue: '', //公司名称
            },
        };
    },
    created() {
        this.getshengfen();
        this.getAgentAccount();
    },
    methods: {
        getAgentAccount() {
            var that = this;
            Axios.get(
                `${this.api.ip}/jeecg-boot/h5/H5Controller2/getAgentAccount`
            ).then((res) => {
                if (res.data.success === true) {
                    that.agentAccount = res.data.result;
                }
            });
        },
        qingKong() {
            var that = this;
            that.formData1.codeTwo = null;
        },
        phoneRule() {
            var that = this;
            if (that.formData1.phoneValue.length === 0) {
                that.phoneR = false;
                return;
            }
            let rule = /^1[3456789]\d{9}$/;
            if (!rule.test(that.formData1.phoneValue)) {
                this.$message.error('请输入正确的手机号！', 1);
                that.phoneR = false;
            } else {
                that.phoneR = true;
            }
        },
        emailRule() {
            var that = this;
            if (that.formData1.eamilValue.length === 0) {
                that.phoneR = false;
                return;
            }
            let rule =
                /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if (!rule.test(that.formData1.eamilValue)) {
                this.$message.error('请输入正确的邮箱号！', 1);
            } else {
                that.emailR = true;
            }
        },
        // 获取省份
        getshengfen() {
            Axios.get(
                `${this.api.ip}/jeecg-boot/h5/h5Controller/getWyProvince`
            ).then((res) => {
                if (res.data.success == true) {
                    this.provinceList = res.data.result;
                }
            });
        },
        // 获取城市
        getCity() {
            this.formData1.cityValue = undefined;
            var that = this;
            var data = {
                provinceId: that.formData1.provinceValue,
            };
            var url =
                'http://118.89.87.102:8080/jeecg-boot/h5/h5Controller/getWyCity?provinceId=' +
                data.provinceId;
            // var url = "http://192.168.1.120:8082/jeecg-boot/h5/h5Controller/getWyCity?provinceId="+data.provinceId;
            Axios.get(url).then((res) => {
                if (res.data.success == true) {
                    that.cityList = res.data.result;
                }
            });
        },
        zx1() {
            if (!this.noArr.includes('models') && !this.formData1.modelsValue) {
                this.$message.error('型号选中不能为空！', 1);
                return false;
            }
            if (
                !this.noArr.includes('province') &&
                !this.formData1.provinceValue
            ) {
                this.$message.error('省份选中不能为空！', 1);
                return false;
            }
            if (!this.noArr.includes('city') && !this.formData1.cityValue) {
                this.$message.error('城市选中不能为空！', 1);
                return false;
            }
            if (!this.noArr.includes('name') && !this.formData1.nameValue) {
                this.$message.error('姓名不能为空！', 1);
                return false;
            }
            if (!this.noArr.includes('phone') && !this.formData1.phoneValue) {
                this.$message.error('手机号码不能为空！', 1);
                return false;
            }
            if (!this.noArr.includes('phone') && this.phoneR === false) {
                this.$message.error('请输入正确的手机号！', 1);
                return false;
            }
            if (!this.noArr.includes('eamil') && !this.formData1.eamilValue) {
                this.$message.error('邮箱不能为空！', 1);
                return false;
            }
            if (!this.noArr.includes('eamil') && this.emailR === false) {
                this.$message.error('请输入正确的邮箱号！', 1);
                return false;
            }
            if (
                !this.noArr.includes('customer') &&
                !this.formData1.customerList
            ) {
                this.$message.error('客户来源选中不能为空！', 1);
                return false;
            }
            if (!this.noArr.includes('codeTwo') && !this.formData1.codeTwo) {
                this.$message.error('邀请码不能为空！', 1);
                return false;
            }
            if (
                !this.noArr.includes('codeTwo') &&
                this.formData1.codeTwo &&
                this.formData1.codeTwo !== 1 &&
                this.formData1.codeTwo !== 2
            ) {
                if (this.agentAccount.indexOf(this.formData1.codeTwo) === -1) {
                    this.$message.error('邀请码无效！', 1);
                    return false;
                }
            }
            if (this.formData1.codeTwo < 0) {
                this.formData1.codeTwo = undefined;
            }

            var data = {
                consultingId: this.type,
                provinceId: this.formData1.provinceValue,
                cityId: this.formData1.cityValue,
                companyNameCn: this.formData1.nameValue,
                phone: this.formData1.phoneValue,
                inviteCode: this.formData1.codeTwo,
            };
            var url =
                'http://118.89.87.102:8080/jeecg-boot/h5/h5Controller/addWyWCustomerConsultation';
            // var url = "http://10.91.44.167:8082/jeecg-boot/h5/h5Controller/addWyWCustomerConsultation";
            Axios.post(url, data).then((res) => {
                if (res.data.success == true) {
                    this.$message.success('提交成功！', 1);
                    this.formData1 = {
                        modelsValue: '', //机型
                        provinceValue: undefined, //省份
                        cityValue: undefined, //城市
                        customerValue: undefined, //客户
                        nameValue: '', //姓名
                        adressValue: '', //详情地址
                        phoneValue: '', //手机号
                        serviceAddress: '', //服务地址
                        eamilValue: '', //电子邮箱
                        codeOne: undefined,
                        codeTwo: undefined,
                        companyValue: '', //公司名称
                    };
                }
            });
        },
        //预约空气检测
        yyAirjiance() {
            if (
                !this.noArr.includes('province') &&
                !this.formData1.provinceValue
            ) {
                this.$message.error('省份选中不能为空！', 1);
                return false;
            }
            if (!this.noArr.includes('city') && !this.formData1.cityValue) {
                this.$message.error('城市选中不能为空！', 1);
                return false;
            }
            if (!this.noArr.includes('name') && !this.formData1.nameValue) {
                this.$message.error('姓名不能为空！', 1);
                return false;
            }
            if (!this.noArr.includes('phone') && !this.formData1.phoneValue) {
                this.$message.error('手机号码不能为空！', 1);
                return false;
            }
            if (!this.noArr.includes('phone') && this.phoneR === false) {
                this.$message.error('请输入正确的手机号！', 1);
                return false;
            }
            if (!this.noArr.includes('codeTwo') && !this.formData1.codeTwo) {
                this.$message.error('邀请码不能为空！', 1);
                return false;
            }
            if (
                !this.noArr.includes('codeTwo') &&
                this.formData1.codeTwo &&
                this.formData1.codeTwo !== 1 &&
                this.formData1.codeTwo !== 2
            ) {
                if (this.agentAccount.indexOf(this.formData1.codeTwo) === -1) {
                    this.$message.error('邀请码无效！', 1);
                    return false;
                }
            }
            if (this.formData1.codeTwo < 0) {
                this.formData1.codeTwo = undefined;
            }
            var data = {
                consultingId: this.type,
                provinceId: this.formData1.provinceValue,
                cityId: this.formData1.cityValue,
                companyNameCn: this.formData1.nameValue,
                phone: this.formData1.phoneValue,
                inviteCode: this.formData1.codeTwo,
            };
            var url =
                'http://118.89.87.102:8080/jeecg-boot/h5/h5Controller/addWyWCustomerConsultation';
            // var url = "http://10.91.44.167:8082/jeecg-boot/h5/h5Controller/addWyWCustomerConsultation";
            Axios.post(url, data).then((res) => {
                if (res.data.success == true) {
                    this.$message.success('安排成功', 1);
                    this.formData1 = {
                        modelsValue: '', //机型
                        provinceValue: undefined, //省份
                        cityValue: undefined, //城市
                        customerValue: undefined, //客户
                        nameValue: '', //姓名
                        adressValue: '', //详情地址
                        phoneValue: '', //手机号
                        serviceAddress: '', //服务地址
                        eamilValue: '', //电子邮箱
                        codeOne: undefined,
                        codeTwo: undefined,
                        companyValue: '', //公司名称
                    };
                }
            });
        },
    },
};
</script>

<style lang="less" scoped>
// ---------------------------- 表格图标 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    .icon_models {
        width: 41px;
        height: 54px;
    }
    .icon_province {
        width: 40px;
        height: 49px;
    }
    .icon_city {
        width: 41px;
        height: 54px;
    }
    .icon_serviceAddress {
        width: 50px;
    }
    .icon_adress {
        width: 50px;
        height: 49px;
    }
    .icon_name {
        width: 43px;
        height: 49px;
    }
    .icon_company {
        width: 45px;
        height: 46px;
    }
    .icon_phone {
        width: 35px;
        height: 53px;
    }
    .icon_eamil {
        width: 50px;
        height: 36px;
    }
    .icon_customer {
        width: 50px;
        height: 50px;
    }
    .icon_code {
        width: 50px;
        height: 52px;
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    .icon_models {
        width: 31px;
        height: 44px;
    }
    .icon_province {
        width: 30px;
        height: 39px;
    }
    .icon_city {
        width: 31px;
        height: 44px;
    }
    .icon_serviceAddress {
        width: 40px;
    }
    .icon_adress {
        width: 40px;
        height: 39px;
    }
    .icon_name {
        width: 33px;
        height: 39px;
    }
    .icon_company {
        width: 35px;
        height: 36px;
    }
    .icon_phone {
        width: 25px;
        height: 43px;
    }
    .icon_eamil {
        width: 40px;
        height: 26px;
    }
    .icon_customer {
        width: 40px;
        height: 40px;
    }
    .icon_code {
        width: 40px;
        height: 42px;
    }
}

// ---------------------------- 表格 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    .forms {
        width: 70%;
        // 表单选项
        .form_box {
            padding: 80px 41px 40px 41px;
            // 图标
            .icon_box {
                width: 80px;
            }
            // 选项
            .options {
                font-size: 50px;
            }
        }
        // 提交按钮
        .button_title {
            font-size: 52px;
            padding: 0 80px;
            line-height: 2.2;
        }
        .button_icon {
            width: 125px;
            img {
                width: 125px;
                height: 115px;
                padding: 20px;
            }
        }
    }
    .options /deep/ .el-input {
        font-size: 52px;
    }
    .form_box /deep/ .el-input__inner {
        height: 80px;
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    .forms {
        width: 45%;
        // 表单选项
        .form_box {
            padding: 60px 41px 20px 41px;
            // 图标
            .icon_box {
                width: 50px;
            }
            // 选项
            .options {
                font-size: 20px;
            }
        }
        // 提交按钮
        .button_title {
            font-size: 22px;
            padding: 0 35px;
            line-height: 0;
        }
        .button_icon {
            img {
                width: 35px;
                height: 35px;
                padding: 6px;
                box-shadow: 0 2px 4px #cad0bb, 0 0 6px #cad0bb;
            }
        }
    }
    .options /deep/ .el-input {
        font-size: 20px;
    }
}
.forms {
    margin: 0 auto;
    // 表单选项
    .form_box {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #676767;
        // 图标
        .icon_box {
            img {
                display: block;
                margin: 0 auto;
            }
        }
        // 选项
        .options {
            background: none;
            border: none;
            width: 95%;
            color: #676767;
            margin-left: 20px;
            outline: none;
        }
    }
    .form_box /deep/ .el-input__inner {
        border: none !important;
        margin-left: -10px !important;
        background: none;
    }
    // 提交按钮
    .form_button {
        margin: 0 auto;
        margin-top: 60px;
        margin-bottom: 60px;
        display: flex;
        justify-content: center;
        // 文字
        .button_title {
            color: #f0844b;
            font-family: '微软雅黑';
            border-radius: 100px 0 0 100px;
            background-color: #fff;
            display: flex;

            align-items: center;
            letter-spacing: 5px;
            box-shadow: 0 2px 4px #cad0bb, 0 0 6px #cad0bb;
            cursor: pointer;
        }
        // 图标
        .button_icon {
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 0px 100px 100px 0px;
            box-shadow: 0 2px 4px #cad0bb, 0 0 6px #cad0bb;
            cursor: pointer;
            background-color: #f0844b;
            img {
                border-radius: 0px 100px 100px 0px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Form.vue